__turbopack_context__.v({
  "Container": "index-module-scss-module__hnkawq__Container",
});
